<div>
  <ng-select [items]="entities"
             dropdownPosition="top"
             [formControl]="entityControl"
             [minTermLength]="0"
             [compareWith]="compareEntities"
             [loading]="loading"
             [typeahead]="entityInput$"
             [clearable]="true"
             [disabled]="false"
             [virtualScroll]="false"
             (clear)="clearValues()"
             (add)="addValue($event)"
             (remove)="removeValue($event.value)"
             (blur)="store.reset()"
             [multiple]="true"
             [readonly]="false"
             typeToSearchText="Пожалуйста, введите символы"
             i18n-typeToSearchText="@@AutocompleteComtrolTypeToSearchText"
               placeholder="Введите название"
             i18n-placeholder="@@EntityAutocompleteLabel"
  >
    <ng-template ng-option-tmp let-item="item">
      <nb-user color="rgba(9, 30, 66, 0.04)"
               size="small"
               [showInitials] = "item.picture === null"
               [name]="item.header"
               [picture]="getImageSrc(item.picture)">
      </nb-user>
    </ng-template>
    <ng-template ng-label-tmp let-item="item">
      <nb-button-group ghost size="tiny">
        <nb-user color="rgba(9, 30, 66, 0.04)"
                 size="tiny"
                 [showInitials] = "item.picture === null"
                 [name]="item.header"
                 [picture]="getImageSrc(item.picture)">
        </nb-user>
        <button nbSuffix nbButton ghost class="dont-reset" size="tiny" nbTooltip="Удалить" (click)="removeValue(item)">
          <nb-icon [icon]="'close-outline'"></nb-icon>
        </button>
      </nb-button-group>
    </ng-template>
  </ng-select>
</div>
